// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6b0d9abf","498":"1b767d42"}[chunkId] + ".chunk.js";
};